/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
import FabricCanvasExercise, { Props } from '../fabricexercise'
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'
class UnderlineWord extends FabricCanvasExercise {
  private options: any[] = []; // Kaynak veriler

  configureCanvas(props: Props) {
    const canvas = this._canvas
    const sources = []
    if (props.currentPageItem.sources) {
      this.options = props.currentPageItem.sources;
    }
    let index = 0
    const coordinate= this._canvas.getBackgroundImageCoordinate()
    for (const option of this.options) {
      const left =coordinate.imgLeft + option.x;
      const top =coordinate.imgTop + option.y;
      const s = new fabric.Rect({
        width: option.width,
        height: option.height,
        strokeWidth: 1,
        opacity: 1,
        stroke: '',
        fill: '',
        left,
        top,
        id: `source-${index}`,
        name: `source-${index}`,
        erasable: false,
        selectable: false,
        hasControls: false,
        hasBorders: false,
        optionId: option.id
      })

      sources.push(s)
      this._canvas.addObject(s)
      index++
    }
    // kaynak elemanların sürükleme özelliklerinin ayarlanması
    sources.forEach(function (source) {
      source.on('mousedown:before', (o: any) => {
        canvas.closeDrawingMode()
      })
      source.on('mousedown', function () {})
      source.on('mouseup', function () {
        canvas.openDrawingMode()
      })
    })
    // this.renderActivityFiles(props, opts)
  }
  onReset = () => {
    this.resetOpenedAnswers()
    const canvas = this._canvas
    const objects = canvas.getObjects()
    const lines = objects.filter((x) => x.id.includes('underline'))
    for (const line of lines) {
      this._canvas.removeObject(line)
    }
  }

  onShowAnswer = async () => {
    this.onReset()
    const timer = (ms: any) => new Promise((res) => setTimeout(res, ms))
    const canvas = this._canvas
    const objects = canvas.getObjects()
    for (const source of objects.filter((x) => x.id.includes('source'))) {
      this.underlineObject(source)
      this.addOpenedAnswers(source.optionId)
      await timer(50)
    }
    this.playSound('solve')
  }
  onShowPreviousAnswer = async () => {
    const canvas = this._canvas
    const showedItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id.includes('underline') &&
          this.getOpenedAnswers().includes(x.optionId)
      )
    if (showedItems.length > 0) {
      const item = showedItems[showedItems.length - 1]
      canvas.removeObject(item)
      this.removeOpenedAnswers(item.optionId)
    }
  }
  onShowNextAnswer = async () => {
    const canvas = this._canvas
    const notShowedItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id.includes('source') &&
          !this.getOpenedAnswers().includes(x.optionId)
      )
    if (notShowedItems.length > 0) {
      const item = notShowedItems[0]
      this.underlineObject(item)
      this.playSound('solve')
      this.addOpenedAnswers(item.optionId)
    }
  }
  doMouseDown(o: any) {
    const canvas = this._canvas
    const pointer = canvas.getPointer(o.e)
    const viewportTransform = canvas.getviewportTransform()
    const transformedPoint = fabric.util.transformPoint(
      pointer,
      viewportTransform
    )
    const objects = canvas.getObjects()
    for (let i = objects.length - 1; i >= 0; i--) {
      if (objects[i].containsPoint(transformedPoint)) {
        const obj = objects[i]
        this.underlineObject(obj)
        break
      }
    }
  }

  doMouseMove(o: any) {}

  doMouseUp(o: any) {}

  destroy() {
    this.resetOpenedAnswers()
  }
}

export default UnderlineWord
